import { Directive, Input, Inject } from '@angular/core';
import { HIGHLIGHT_JS } from './highlightJs.token';
var HighlightJsDirective = (function () {
    function HighlightJsDirective(hljs) {
        this.hljs = hljs;
    } //tslint:disable-line
    HighlightJsDirective.prototype.ngOnChanges = function (changes) {
        if ((changes['source'] || changes['language']) && this.language && this.source) {
            this.highlightedCode = this.hljs.highlight(this.language, this.source).value;
        }
    };
    HighlightJsDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[mwlHighlightJs]',
                    host: {
                        '[innerHTML]': 'highlightedCode'
                    }
                },] },
    ];
    /** @nocollapse */
    HighlightJsDirective.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [HIGHLIGHT_JS,] },] },
    ]; };
    HighlightJsDirective.propDecorators = {
        'source': [{ type: Input },],
        'language': [{ type: Input },],
    };
    return HighlightJsDirective;
}());
export { HighlightJsDirective };
//# sourceMappingURL=highlightJs.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-highlight-js/dist/esm/src/highlightJs.directive.js
// module id = ./node_modules/angular-highlight-js/dist/esm/src/highlightJs.directive.js
// module chunks = common